import {Component, OnInit} from '@angular/core';
import {ZendeskService} from '../../../core/services/zendesk.service';
import { MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-confirm-become-beta-dialog',
    templateUrl: './confirm-become-beta-dialog.component.html',
    standalone: true,
    imports: [
        MatDialogTitle,
        CdkScrollable,
        MatDialogContent,
        MatDialogActions,
        MatButton,
        MatDialogClose,
    ],
})
export class ConfirmBecomeBetaDialogComponent implements OnInit {

  constructor(public zendeskService: ZendeskService) {}

  ngOnInit() {
  }

  openSupportWidget() {
    this.zendeskService.toggle();
  }
}
